import { BookingListing } from "api/users/getMyBookings";

export const groupBookingsByDate = (bookings: BookingListing[]) => {
  const grouped = new Map<string, BookingListing[]>();
  bookings.forEach((booking) => {
    const date = new Date(booking.startTime).toLocaleDateString();
    if (!grouped.has(date)) {
      grouped.set(date, []);
    }
    grouped.get(date)?.push(booking);
  });
  return grouped;
};
